import React from 'react';
import IconProps from '../../icons';

const XClose = ({ width = 24, color = 'var(--gray-light-700)', className = '' }: IconProps): JSX.Element => (
  <svg
    fill='none'
    width={width}
    viewBox='0 0 24 24'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M18 6L6 18M6 6L18 18'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default XClose;
